import styled from "styled-components";

export const ListContainer = styled.div`
    overflow-x: hidden;
    overflow-y: auto;
`;

export default ListContainer;
